import { Card, CardContent } from '@mui/material';

import { useConfig } from '@occc/config';
import { TriggeredMessagesToolboxItem } from '@occc/feat-triggered-messages';
import { Page, ToolboxContainer, ToolboxItem, ToolboxItemType } from '@occc-app/design-system';
import { Typography } from '@occc/ui-design-system';
import { useIsUserPermittedTo } from '@occc/utils-access-control';
import { Feature } from '@occc/utils-access-control';

import { CONFIGURE_PAGE_SUBTITLE, PAGE_SUBTITLE, PAGE_TITLE } from './messaging-center.constants';
import { routeCreator as messagingCenterRouteCreator } from './messaging-center.utils';

export const MessagingCenterPage = () => {
  const isMessagingCenterEnabled = useConfig('features.messagingCenterEnabled');
  const isTriggeredMessagesEnabled = useConfig('triggeredMessages.enabled');
  const isUserPermittedToCreateMessagingCampaigns = useIsUserPermittedTo(
    Feature.MESSAGING_CENTER_CREATE,
  );
  const showPlaceholder =
    (isMessagingCenterEnabled && !isTriggeredMessagesEnabled) ||
    (!isMessagingCenterEnabled && isTriggeredMessagesEnabled);

  return (
    <Page
      browserTabTitle={PAGE_TITLE}
      pageHeaderProps={{
        title: PAGE_TITLE,
        subtitle: PAGE_SUBTITLE,
      }}
    >
      <Card>
        <CardContent>
          <Typography sx={{ mb: 3 }} variant='subtitle1'>
            Start by Selecting a Message Type
          </Typography>
          <ToolboxContainer>
            {isMessagingCenterEnabled && (
              <ToolboxItem
                title='SMS/Push Notification'
                description={CONFIGURE_PAGE_SUBTITLE}
                type={ToolboxItemType.SmsOrPushNotification}
                linkToCreate={
                  isUserPermittedToCreateMessagingCampaigns
                    ? messagingCenterRouteCreator.campaignCreate()
                    : undefined
                }
                linkToDetails={messagingCenterRouteCreator.campaignsList()}
              />
            )}
            {isTriggeredMessagesEnabled && <TriggeredMessagesToolboxItem />}
            {showPlaceholder ? <div></div> : null}
          </ToolboxContainer>
        </CardContent>
      </Card>
    </Page>
  );
};
